import { pdfPreviewAssets } from "./pdfPreviewAssets";

export const pdfPreviews = [
  {
    "id": "agenda",
    "page": "04",
    "label": "30-minute session agenda",
    "heading": "Every minute already has a purpose",
    "text": "A complete session timeline, role-rotation table and group arrangements. The structure is ready before you start preparing.",
    "alt": "Actual Volume 1 page 4: The 30-Minute Session, including a timed agenda, role rotations and group arrangements."
  },
  {
    "id": "facilitator",
    "page": "08",
    "label": "Ready-to-run workshop plan",
    "heading": "Know what to do, say and prepare",
    "text": "A workshop objective, preparation checklist, timed activities and facilitator transitions, written together in one plan.",
    "alt": "Actual Volume 1 page 8: Workshop 1 facilitator plan with objectives, preparation checklist, timed agenda and transition wording."
  },
  {
    "id": "roles",
    "page": "12",
    "label": "Printable seller & buyer cards",
    "heading": "The scenario is written for your team",
    "text": "Complete role cards give each participant a brief and a clear task. You do not have to invent a customer or write a case.",
    "alt": "Actual Volume 1 page 12: Workshop 1 Case B seller and buyer role cards, with scenario details and a separation line."
  },
  {
    "id": "dialogue",
    "page": "33",
    "label": "Price-objection model dialogue",
    "heading": "An example you can demonstrate and discuss",
    "text": "An annotated price conversation, a weak response compared with a stronger one, plus debrief and application prompts.",
    "alt": "Actual Volume 1 page 33: a ClearDesk price conversation with Jordan, annotated dialogue, response comparison and debrief prompts."
  },
  {
    "id": "observation",
    "page": "38",
    "label": "Reusable observation sheet",
    "heading": "The feedback process is planned too",
    "text": "Observable behaviors, recording columns and a completed example help the observer give specific feedback during the practice.",
    "alt": "Actual Volume 1 page 38: reusable observation master with behavioral criteria, scoring columns and a completed example."
  }
].map(page => ({ ...page, src: pdfPreviewAssets[page.page] }));
